const token = localStorage.getItem('token') || '';
import env from '../enviroments/enviroment';

const getProductFileReq = async (id: number) => {
  const response = await fetch(
    `${env.base_url}/products/${id}/image`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return {blob: await response.blob(), ok: response.ok};
};

export default getProductFileReq;
